import api from "../../api/api";
import API_URL from "../../api/url";
import axios from 'axios';


const CouponsRequest = {
  couponList: (values) => api.get(`${API_URL.BASEURL}${API_URL.coupons}`, {
    params: {
      search: values?.search,
         page: values?.page,
    
      limit: 10, 
    }
  }),

  createCoupon: (values) => api.post(`${API_URL.BASEURL}${API_URL.createCoupon}`, values),

  deleteCoupon: (couponId) => api.post(`${API_URL.BASEURL}${API_URL.deleteCoupon}?couponId=${couponId}`,),
  updateCoupon: (values) => api.post(`${API_URL.BASEURL}${API_URL.updateCoupon}`, values),
  couponDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.couponDetails}?couponId=${id}`),
  updateCouponStatus :  (values) => api.post(`${API_URL.BASEURL}${API_URL.updateCouponStatus}`, values),


}
export default CouponsRequest